export function getAction(letter) {
  return {
    id: 'letter',
    document_template: letter.template_id,
    recipient_id: letter.recipient_id,
    document_id: letter.document_node__id,
    tooth_chart_snapshot_id: letter.tooth_chart_snapshot_id,
    tooth_marking_ids: letter.tooth_marking_ids,
  }
}
